<template>
  <b-container class="bg-light m-0 p-0" fluid>
    <b-row class="g-0">
      <!-- Main Panel-->
      <b-col class="main-panel bg-light p-0 m-0">
        <div>
          <b-carousel
            v-if="$route.name === 'Landing-view'"
            id="carousel-1"
            v-model="slide"
            :interval="3000"
            controls
            fade
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333; max-height: 400px;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide>
              <template #img>
                <img
                  class="w-100 hero-image"
                  src="https://www.trailfinders.com/graphics/giftlist/bg/honeymoon-banner-cropped.jpg"
                  alt="image slot"
                /> </template
            ></b-carousel-slide>

            <b-carousel-slide>
              <template #img>
                <img
                  fluid
                  class="w-100 hero-image"
                  src="https://www.trailfinders.com/graphics/giftlist/bg/honeymoon-banner-cropped2.jpg"
                  alt="image slot"
                />
              </template>
            </b-carousel-slide>
          </b-carousel>

          <b-carousel
            v-else-if="
              $store.state.wishlistType === 'wishlist' ||
                $route.params.wishlistType === 'wishlist' ||
                $route.params.wishlistType === 'honeymoon'
            "
            id="carousel-1"
            v-model="slide"
            background="#ababab"
            :interval="3000"
            img-width="50"
            img-height="50"
            style="text-shadow: 1px 1px 2px #333; position: relative; "
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              img-src="https://www.trailfinders.com/graphics/weddings/bg/bg-hero-image-lg-ss-ie.jpg"
            >
              <div
                v-if="$store.state.wishlistType === 'wishlist'"
                id="loggedIn-banner-image"
              >
                <span class="part-1"> Welcome to </span><br />
                <span class="part-2"
                  >{{ $store.state.user.couple_title }}'s Honeymoon
                  Wishlist</span
                >
              </div>
            </b-carousel-slide>
          </b-carousel>

          <b-carousel
            v-else-if="
              ($route.name !== 'Landing-view' &&
                $store.state.wishlistType === 'giftlist') ||
                $route.params.wishlistType === 'giftlist'
            "
            id="carousel-1"
            v-model="slide"
            background="#ababab"
            :interval="3000"
            img-width="50"
            img-height="50"
            style="text-shadow: 1px 1px 2px #333; "
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              img-src="https://cdn.trailfinders.com/bx46kutlt7_honeymoon-banner-cropped2.jpg"
            >
              <div
                v-if="
                  $store.state.wishlistType === 'giftlist' &&
                    $store.state.user.surname
                "
                id="loggedIn-banner-image"
              >
                <span
                  v-if="
                    $store.state.wishlistType === 'giftlist' &&
                      $store.state.user !== []
                  "
                  class="part-1"
                >
                  Welcome to </span
                ><br />
                <span
                  v-if="
                    $store.state.wishlistType === 'giftlist' &&
                      $store.state.user !== []
                  "
                  class="part-2"
                  >{{ $store.state.user.couple_title }}'s
                  {{ $store.state.user.type }} Wishlist</span
                >
              </div>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </b-col>
      <!-- /Main Panel-->
    </b-row>

    <b-row class="justify-content-center">
      <!--Sidebar Panel-->
      <SidebarNav class="justify-content-center">
        <b-row>
          <b-col sm="12">
            <b-nav
              vertical
              v-if="
                $store.state.wishlistType === 'giftlist' &&
                  $route.params.wishlistType === 'honeymoon' &&
                  $route.name.includes('Register-view') |
                    $route.name.includes('Terms-And-Conditions') |
                    $route.name.includes('Wishlist-example-guestcard')
              "
              class="sidebar-wishlist-nav"
            >
              <b-nav-item
                v-if="$route.path === '/'"
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Wishlist Homepage
              </b-nav-item>
              <b-nav-item
                v-else
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Return To Main Menu
              </b-nav-item>
              <b-nav-item
                v-if="$route.params.wishlistType === 'honeymoon'"
                exact
                exact-active-class="active"
                class="btn"
                to="/honeymoon/terms-and-conditions"
              >
                How your Wishlist works
              </b-nav-item>
              <b-nav-item
                v-if="$route.params.wishlistType === 'honeymoon'"
                exact
                exact-active-class="active"
                class="btn"
                to="/honeymoon/example-guestcard"
              >
                Example Guest Card
              </b-nav-item>
              <button
                v-if="$store.state.user.surname"
                class="btn btn-sm mt-1"
                style="background-color: transparent; color: pink; font-size: large; width: 60%; margin-left: 20%; font-weight: 600;"
                @click="logout()"
              >
                Logout
              </button>
              <br />
              <br />
              <p class="text-center">
                Call our dedicated Honeymoon &amp; Wishlist set up team
                <br />
                <strong
                  ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link_cta' : null">{{ telNo }}</a></strong
                >
                <br />
                Wishlist Admin Support
                <br />
                <strong
                  ><a :href="`tel:${adminTelNo}`" :data-ga4-label="adminTelNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="adminTelNo === '020 7368 1404' ? 'text_link_cta' : null">{{ adminTelNo }}</a></strong
                >
                <br />
                <br />
                Lines Are Open
                <br />
                <strong v-if="isIe">
                  Monday - Friday 9am-7pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <strong v-if="!isIe">
                  Monday - Friday 8am-8pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <br />
                <br />
              </p>
            </b-nav>

            <b-nav
              vertical
              v-else-if="
                ($store.state.wishlistType === 'giftlist') |
                  ($route.params.wishlistType === 'giftlist') &&
                  !$route.name.includes('Landing-view')
              "
              class="sidebar-giftlist-nav"
            >
              <b-nav-item
                v-if="$route.path === '/'"
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Wishlist Homepage
              </b-nav-item>
              <b-nav-item
                v-else
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Return To Main Menu
              </b-nav-item>
              <b-nav-item
                exact
                exact-active-class="active"
                class="btn"
                to="/giftlist/terms-and-conditions"
              >
                How Your Wishlist Works
              </b-nav-item>
              <b-nav-item
                exact
                exact-active-class="active"
                class="btn"
                to="/giftlist/example-guestcard"
              >
                Example Guest Card
              </b-nav-item>
              <button
                v-if="$store.state.user.surname"
                class="btn btn-sm mt-1"
                style="background-color: transparent; color: orange; font-size: large; width: 60%; margin-left: 20%; font-weight: 600;"
                @click="logout()"
              >
                Logout
              </button>
              <br />
              <br />
              <hr class="hr-02" />

              <p class="text-center">
                Call our dedicated Honeymoon &amp; Celebration Wishlist set up team
                <br />
                <strong
                  ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link_cta' : null">{{ telNo }}</a></strong
                >
                <br />
                Wishlist Admin Support
                <br />
                <strong
                  ><a :href="`tel:${adminTelNo}`" :data-ga4-label="adminTelNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="adminTelNo === '020 7368 1404' ? 'text_link_cta' : null">{{ adminTelNo }}</a></strong
                >
                <br />
                <br />
                Lines Are Open
                <br />
                <strong v-if="isIe">
                  Monday - Friday 9am-7pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <strong v-if="!isIe">
                  Monday - Friday 8am-8pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <br />
                <br />
              </p>
            </b-nav>

            <p
              class="text-center"
              v-else-if="$route.name.includes('Landing-view')"
            >
            Call our dedicated Honeymoon &amp; Celebration Wishlist set up team
              <br />
              <strong
                ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link_cta' : null">{{ telNo }}</a></strong
              >
              <br />
              Wishlist Admin Support
              <br />
              <strong
                ><a :href="`tel:${adminTelNo}`" :data-ga4-label="adminTelNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="adminTelNo === '020 7368 1404' ? 'text_link_cta' : null">{{ adminTelNo }}</a></strong
              >
              <br />
              <br />
              Lines Are Open
              <br />
              <strong v-if="isIe">
                Monday - Friday 9am-7pm<br />
                Saturday 9am-6pm<br />
                Sunday 10am-6pm
              </strong>
              <strong v-if="!isIe">
                Monday - Friday 8am-8pm<br />
                Saturday 9am-6pm<br />
                Sunday 10am-6pm
              </strong>
              <br />
              <br />
            </p>

            <b-nav
              vertical
              v-else-if="
                ($store.state.wishlistType === 'wishlist') |
                  ($route.params.wishlistType === 'wishlist') &&
                  !$route.name.includes('Landing-view')
              "
              class="sidebar-wishlist-nav"
            >
              <b-nav-item
                v-if="$route.path === '/'"
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Wishlist Homepage
              </b-nav-item>
              <b-nav-item
                v-else
                exact
                exact-active-class="active"
                class="btn"
                to="/"
              >
                Return To Main Menu
              </b-nav-item>
              <b-nav-item
                exact
                exact-active-class="active"
                class="btn"
                to="/honeymoon/terms-and-conditions"
              >
                How Your Wishlist Works
              </b-nav-item>
              <b-nav-item
                exact
                exact-active-class="active"
                class="btn"
                to="/honeymoon/example-guestcard"
              >
                Example Guest Card
              </b-nav-item>
              <button
                v-if="$store.state.user.surname"
                class="btn btn-sm mt-1"
                style="background-color: transparent; color: pink; font-size: large; width: 60%; margin-left: 20%; font-weight: 600;"
                @click="logout()"
              >
                Logout
              </button>
              <br />
              <br />
              <p class="text-center">
                Call our dedicated Honeymoon &amp; Wishlist set up team
                <br />
                <strong
                  ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link_cta' : null">{{ telNo }}</a></strong
                >
                <br />
                Wishlist Admin Support
                <br />
                <strong
                  ><a :href="`tel:${adminTelNo}`" :data-ga4-label="adminTelNo === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="adminTelNo === '020 7368 1404' ? 'text_link_cta' : null">{{ adminTelNo }}</a></strong
                >
                <br />
                <br />
                Lines Are Open
                <br />
                <strong v-if="isIe">
                  Monday - Friday 9am-7pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <strong v-if="!isIe">
                  Monday - Friday 8am-8pm<br />
                  Saturday 9am-6pm<br />
                  Sunday 10am-6pm
                </strong>
                <br />
                <br />
              </p>
            </b-nav>
          </b-col>
        </b-row>
      </SidebarNav>
      <!-- /Sidebar Panel-->

      <!-- Page Loader -->
      <b-col v-if="!loaded">
        <div class="text-center">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      </b-col>
      <!-- /Page Loader -->

      <!-- Page content -->
      <b-col v-if="loaded" class="ps-0 pe-0 col-12 col-md-9" :class="colWidth">
        <b-container>
          <slot> </slot>
        </b-container>
      </b-col>
      <!-- /Page content -->
    </b-row>

    <!-- Go Back button -->
    <b-row v-if="back">
      <b-col>
        <div class="btn-group" role="group" aria-label="Basic example">
          <button type="button" class="btn btn-secondary">
            <span aria-hidden="true">&laquo;</span> Back
          </button>
        </div>
      </b-col>
    </b-row>
    <!-- /Go Back button -->
  </b-container>
</template>

<script>
import SidebarNav from "@/Components/SidebarNav/index.vue";
import { Glide, GlideSlide } from "vue-glide-js";
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      isIe: false,
      telNo: null,
      adminTelNo: null,
      colWidth: 12
    };
  },
  components: {
    SidebarNav,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide
  },

  props: {
    screenWidth: Number,
    back: String,
    title: String,
    subheading: String,
    loaded: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    goBack() {
      this.$router.push(this.back);
    },
    goHome() {
      this.$router.go("/");
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (window.innerWidth < 790) {
        this.vertical = true;
      } else {
        this.vertical = false;
      }
      if (window.innerWidth > 1920) {
        this.colWidth = "col-xxl-4";
        // this.colWidth = "col-xxl-4";
      } else {
        this.colWidth = "";
      }
      return this.colWidth;
    },
    logout() {
      this.$store.state.user = [];
      this.$store.state.wishlistType = "giftlist";

      this.$router.push({ path: "/" });
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true;
      this.telNo = "01 881 4990";
      this.adminTelNo = "01 881 4950";
    } else {
      this.isIe = false;
      this.telNo = "020 7084 6512";
      this.adminTelNo = "020 7368 1404";
    }

    if (window.innerWidth > 1920) {
      this.colWidth = "";
      // this.colWidth = "col-xxl-4";
    }
    return this.colWidth;
  }
};
</script>

<style>
.sidebar-wishlist-nav .nav-item a {
  color: pink;
}

.sidebar-wishlist-nav .nav-item a:hover {
  color: pink;
}

.sidebar-wishlist-nav .nav-item a.active {
  font-weight: 600;
  color: pink;
}
.sidebar-giftlist-nav .nav-item a {
  color: orange;
}

.sidebar-giftlist-nav .nav-item a:hover {
  color: orange;
}

.sidebar-giftlist-nav .nav-item a.active {
  font-weight: 600;
  color: orange;
}

#side-nav-button {
  margin-top: 2.5%;
  margin-bottom: 2.5%;
}
.bestPractice {
  padding: 8px 16px !important;
}
.part-1 {
  font-size: 16px;
  font-weight: 800;
  font-family: "Open Sans", Verdana, Arial, sans-serif;
  line-height: 13px;
}
.part-2 {
  font-size: 32px;
  font-weight: 400;
  font-family: "Alegreya", Georgia, Time Roman, serif;
  line-height: 19px;
}
#loggedIn-banner-image {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: black;
  opacity: 50%;
  padding-top: 1%;
  padding-bottom: 1%;
  width: 100%;
  padding-left: 1%;
}
@media only screen and (max-width: 1040px) {
  .part-1 {
    font-size: small;
    font-weight: 800;
    font-family: "Open Sans", Verdana, Arial, sans-serif;
    line-height: 13px;
  }
  .part-2 {
    font-size: small;
    font-weight: 400;
    font-family: "Alegreya", Georgia, Time Roman, serif;
    line-height: 19px;
  }
}
.modal-header {
  padding: 1rem 1rem !important;
  border-bottom: 1px solid #dee2e6 !important;
}
.dropdown-toggle-wishlist {
  position: relative;
}
.modal-title {
  margin: 0 !important;
}
.express-vue-temp .carousel-caption {
  right: 15%;
  bottom: 0 !important;
  left: 0%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: left;
  position: absolute;
  width: 100%;
}
.sr-only {
  display: none;
}
.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0 auto;
  overflow: hidden;
  opacity: 0;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-file-input[disabled] ~ .custom-file-label,
.custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}
.form-file-text {
  text-align: left;
}
</style>
